import React, { useContext,useState } from 'react';

import { 
    Alert,
    AlertTitle,
    Box
} from '@mui/material';

import ProjectContext from '../../contexts/ProjectContext';
import {useFetch} from '../../components/auth/useFetch';

import FdlButton from '../buttons/FdlButton'
import FormField from '../formfield/FormField';
import HelpTooltip from '../popover/HelpTooltip';


export default function FramingIntentsForm(props) {
    const projectContext = useContext(ProjectContext);
    const { style, display, intentsDataStore, setIntentsDataStore, setCurrentForm, formScrollRef } = props;
    const [formErrorText, setFormErrorText] = useState('');
    const [subheadingExtended, setSubheadingExtended] = useState(false);
    const [subheadingExtendedButtonText, setSubheadingExtendedButtonText] = useState('Read More');
    const fetchWithAuth = useFetch()



    const containerStyle = {
        display: display,
        ...style
    };
    
    const formErrorTextStyle = {
        opacity: formErrorText? 0.7 : 0,
        width: '70%',
        marginTop: '15px'
    }

    const finishedButtonStyle = {
        backgroundColor: 'green'
    };

    const bottomButtonContainer = {
        width: '90%',
        display: 'flex',
        gap: '20px',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
    };

    const headerStyle = {
        marginBottom: '15px',
        marginTop: '0px',
        textAlign:'left'
    }

    const subheadingStyle = {
        color: 'grey',
        margin: '0',
        textAlign:'left'
    }

    const subheadingReadmoreStyle = {
        color: 'grey',
        margin: '0',
        display: subheadingExtended ? 'block' : 'none',
        marginTop: '20px',
        textAlign:'left'
    }

    const toggleSubheadingButtonStyle = {
        color: 'silver',
        marginBottom: '20px',
        backgroundColor: 'rgba(0,0,0,0)',
        padding: '0',
        boxShadow: 'none'
        
    }

  

    function toggleSubheadingExtended(){
        subheadingExtended ? setSubheadingExtended(false) : setSubheadingExtended(true);
        subheadingExtended ? setSubheadingExtendedButtonText('Read More') : setSubheadingExtendedButtonText('Read Less');
    }
     
    
    async function handleSubmit(event) {
        event.preventDefault();
        let formObject = event.currentTarget;

        const data = new FormData(event.currentTarget);
        let tempDataStore = intentsDataStore;
        let newKey = 'Error, no label entered';
        let newData = {};
        let intentID;
        for (const entry of data.entries()) {
            if (entry !== undefined) {
                if (entry[0] === 'Intent Label') {
                    intentID = entry[1]
                    newKey = entry[1]
                    newData[`${entry[0]}`] = entry[1]
                } else {
                    newData[`${entry[0]}`] = entry[1]
                }
            }
        }

        let fetchDetails = {
            method: "POST",
            body: JSON.stringify({
                'dataType': 'intent', 
                'data': newData,
                'allIntentsData': intentsDataStore,
                'action': 'create'
            }),
            headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db}
        };
            
        let response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlvalidateinputone/`, fetchDetails);
        let result = await response.json();
    
        if(result['passed'] === 'fail'){
            setFormErrorText(result['reason'])
            window.scrollTo({top: window.innerHeight, behavior: 'smooth'});
        }
        else{
            tempDataStore[newKey] = newData;
            setIntentsDataStore((prevState) => ({
                ...prevState
            }));
            setFormErrorText('')
            // Reset form
            formObject.reset();
        }
        
    };

    function finishSection(event) {
        setCurrentForm('camera');
    };

    return (
        <div style={containerStyle}>
            <h2 style={headerStyle}>Add Framing Intent
            <HelpTooltip 
                text="Describe a Framing Intent. This represents the intended aspect ratio, unbounded by the constraints of any camera or device." 
            />
            </h2>
            <Box component='form' onSubmit={handleSubmit}
                autoComplete="off"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap'
                }}
            >
                <FormField
                    name='Intent Label'
                    label='Intent Label'
                    fontSize='10px'
                    units=''
                    placeholder='Dailies 02'
                    toolTip="Name this framing intent."
                    helperTextDefault=" "
                />
                <FormField
                    name='Intent ID'
                    label='Intent ID'
                    fontSize='10px'
                    units=''
                    placeholder='dailies_02'
                    required
                    validationType='id'
                    toolTip="Give your framing intent an ID. This must be unique within the project."
                    helperTextDefault=" "
                />
                <FormField
                    name='Aspect Ratio X'
                    label='Aspect Ratio X'
                    pair={true}
                    fontSize='10px'
                    units=''
                    placeholder='16'
                    required
                    validationType='number'
                    toolTip="No decimals allowed. For example, 2.76:1 should be entered as 276 and 100."
                    helperTextDefault=" "
                />
                <FormField
                    name='Aspect Ratio Y'
                    label='Aspect Ratio Y'
                    pair={true}
                    fontSize='10px'
                    units=''
                    placeholder='9'
                    required
                    validationType='number'
                    toolTip="No decimals allowed. For example, 2.76:1 should be entered as 276 and 100."
                    helperTextDefault=" "
                />
                <FormField
                    name='Protection'
                    label='Protection'
                    fontSize='10px'
                    units=''
                    placeholder='0.00'
                    required
                    validationType='protection'
                    toolTip="Percentage of safety margin around the framing intent"
                    helperTextDefault=" "
                />
                <div style={bottomButtonContainer}>
                    <FdlButton type='submit' text="Save framing intent"></FdlButton>
                    <FdlButton style={finishedButtonStyle} text="Finished adding framing intents" onClick={finishSection}></FdlButton>
                </div>
                <Alert severity='error' style={formErrorTextStyle}>
                    <AlertTitle>Form submission error:</AlertTitle>
                    {formErrorText}
                </Alert>
            </Box>
        </div>
    );
};